/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeActionItem,
  BaSeButton,
  BaSeContainer,
  BaSeDatePicker,
  BaSeHeading4,
  BaSeParagraph,
  BaSeShapeButton,
  BaSeSmall1,
  BaSeTheme,
  BaSeToggler,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';

import { format } from 'date-fns';
import * as React from 'react';
import { useAnswerController } from '../../../../hooks/controllers/answer-controller';
import { useEmailController } from '../../../../hooks/controllers/email-controller';
import { useInterviewController } from '../../../../hooks/controllers/interview-controller';
import { useReportController } from '../../../../hooks/controllers/report-controller';
import { useMessage } from '../../../../hooks/messages/useMessage';
import { useModule } from '../../../../hooks/module/module';
import { useInterviewService } from '../../../../hooks/services/interview-service.js';
import { useRegionalService } from '../../../../hooks/services/regional-service.js';
import { DATE_REGEX } from '../../../../utils/validators/constants';
import { ColumnFilter } from '../../components/data-table/column-filter';
import { ColumnRuralFilter } from '../../components/data-table/column-rural-filter.jsx';
import { DataRegister } from '../../components/data-table/data-register.jsx';
import { EmailDate } from '../../components/data-table/email-date';
import { InterviewResult } from '../../components/data-table/interview-result';
import { InterviewStatus } from '../../components/data-table/interview-status';
import { PersonalData } from '../../components/data-table/personal-data';
import { SituationRural } from '../../components/data-table/situation-rural.jsx';
import { ContentContext } from '../../context/content-context';
import { useTableInterview } from '../../context/table-interview-context.jsx';
import ManageRegional from '../manage-regional/manage-regional.jsx';
import {
  AlignFilds,
  Banner,
  BoxHeader,
  BoxUserName,
  Content,
  ContentActions,
  ContentOptions,
  CustomFilterWrapper,
  CustomFilterWrapperAlign,
  DataTableWrapper,
  ItemResultEntrevista,
  ListContainer,
} from './candidates-styled';
import SelectionActionsButtons from './components/SelectionActionsButtons/selection-actions-buttons.jsx';
import ManageClass from './components/manage-class/manage-class.jsx';
import { NewClassRoomContext } from './context/new-class-room-context.jsx';
import { useConfigTable } from './hook/useConfigTable';
import { useGeneralSearch } from './hook/useGeneralSearch';
import { useManageClass } from './hook/useManageClass';
import { useMenu } from './hook/useMenu.jsx';
import { useReginal } from './hook/useRegiona..jsx';
import MainContent from './main-content';

const hasCustomFilter = true;
const cache = Sebrae.StorageUtil.inTemporaryStore();
const cacheKey = '@empretec:cpfSearched';
const cacheKeySebrae = '@empretec:sebrae';

// eslint-disable-next-line sonarjs/cognitive-complexity
export const Candidates = () => {
  const { moduleSelected } = useModule();
  const { isAuthenticated, tokenInfo, hasRole } = Sebrae.useAuth();
  // const [cpfSearched, setCpfSearched] = React.useState('');
  const { getQueryString } = Sebrae.useRouter();
  const { clear, cpfSearched } = useGeneralSearch();
  const { hasAlertAwaitinAvaliation } = useInterviewService();

  const { getDownloadCertificate } = useInterviewController();

  const { fetchData, data, loading } = useTableInterview();
  const {
    loading: loadingRegional,
    data: dataRegional,
    fetchRegional,
  } = useRegionalService();

  const { resendAnswerInterviewmutiple } = useAnswerController();

  const { sendEmailSubscription } = useEmailController();
  const { downloadPdf, getClassReport } = useReportController();
  const { handleSuccess, handleError, handleAttention } = useMessage();
  const { settingsTable } = useConfigTable();

  const [myRecords, setMyRecords] = React.useState(false);
  const [initialDate, setInitialDate] = React.useState();
  const [finalDate, setFinalDate] = React.useState();
  const [initialProcessingDate, setInitialProcessingDate] = React.useState();
  const [finalProcessingDate, setFinalProcessingDate] = React.useState();

  const { showContentManageClass, showManagerRegional } =
    React.useContext(ContentContext);
  const [itemsSelectTable, setItemsSelectTable] = React.useState([]);
  const [isAllSelect, setIsAllSelect] = React.useState(false);

  const { filters, handleColumns } = React.useContext(NewClassRoomContext);

  const {
    respostas,
    showNotas,
    notasRespostas,
    openDialogCpf,
    setShowNotas,
    openDialogNewCandidate,
    openDialogActiveInterview,
    openDialogVisualizarHistorico,
    formatDate,
    setCodigoRespostas,
    openDialogGenerateCertificate,
    openDialogSendMultipleCertificate,
    showAvaliableCandidate,
    setShowAvaliableCandidate,
    respostasQuestionarioStartup,
    getInterviewDataStartup,
    hasApprove,
    setHasApprove,
    showAvaliableRuralCandidate,
    dataToAvaliationRural,
    setShowAvaliableRuralCandidate,
    getMenuItems,
  } = useMenu();
  const { openDialogNewRegional } = useReginal();

  const { openDialogNewClassRoom } = useManageClass();

  const historico = (values) => {
    openDialogVisualizarHistorico(values);
    setCodigoRespostas(values.id);
  };

  React.useEffect(() => {
    if (!hasRole('ADMINISTRADOR')) return;
    hasAlertAwaitinAvaliation()
      .then((response) => {
        if (response) {
          handleAttention(
            ' Existe(m) entrevista(s) no sistema "Aguardando avaliação".',
          );
        }
      })
      .catch(() => {
        handleError(
          'Erro ao analisar se existem entrevistas Aguardando avaliação.',
        );
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleAttention, handleError, hasRole]);

  React.useEffect(() => {
    const interview = getQueryString('interview');

    if (interview) {
      getInterviewDataStartup(interview);
      setShowAvaliableCandidate(true);
    }
  }, [
    moduleSelected,
    getQueryString,
    getInterviewDataStartup,
    setShowAvaliableCandidate,
  ]);

  const textFilter = React.useCallback((setFilter, term) => {
    if (
      cache.hasItem(cacheKeySebrae) &&
      cache.getItem(cacheKeySebrae) !== 'NA' &&
      term === ''
    ) {
      setFilter((currentFilter) => ({
        ...currentFilter,
        ufs: [cache.getItem(cacheKeySebrae)],
        fieldOfResearch: term,
      }));
      return;
    }
    setFilter((currentFilter) => ({
      ...currentFilter,
      ufs: '',
      fieldOfResearch: term,
    }));
  }, []);

  const commonConfigTable = [
    {
      accessorKey: 'candidate.name',
      header: 'Dados pessoais',
      mapper: ({ values }) => <PersonalData props={values} />,
    },
    {
      accessorKey: 'city.uf.initials',
      header: 'UF',
      mapper: ({ values }) => {
        return (
          <BaSeSmall1
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae45}
          >
            {values.city.uf.initials}
          </BaSeSmall1>
        );
      },
    },
    {
      accessorKey: 'city.name',
      header: 'Cidade',
      mapper: ({ values }) => (
        <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
          {values.city.name}
        </BaSeSmall1>
      ),
    },
  ];

  const configRuralTable = [
    ...commonConfigTable,
    {
      id: 'registerData',
      accessorKey: 'registerData',
      header: 'Data de inscrição',
      mapper: ({ values }) => <DataRegister props={values} />,
    },
    {
      accessorKey: 'situationInterview',
      header: 'Situação do participante',
      mapper: ({ values }) => {
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <SituationRural props={values} />
            <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
              {values.processingDate
                ? ` ${settingsTable.processingDateTitle}: ${formatDate(
                    new Date(values.processingDate),
                  )}`
                : ''}
            </BaSeSmall1>
          </div>
        );
      },
    },
    {
      header: 'Opções',
      mapper: ({ values, reloadData }) => (
        <ContentOptions>
          <BaSeActionItem
            position="top-right"
            minWidth="310px"
            closeOnAction={false}
            color={BaSeTheme.colors.institucionais.azulSebrae10}
            items={getMenuItems(values, reloadData, 1)}
          />
          {values.hasHistoric && (
            <BaSeShapeButton
              buttonType="button"
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
              nameIcon="file-search-alt"
              onClick={() => {
                historico(values);
              }}
              shape="square"
              size="medium"
              sizeIcon="medium"
              tooltip={{
                width: '150',
                direction: 'bottom',
                message: 'Visualizar histórico',
                color: `${BaSeTheme.colors.institucionais.cinzaSebrae60}`,
              }}
              type="tertiary"
            />
          )}
        </ContentOptions>
      ),
    },
  ];

  const configTable = [
    ...commonConfigTable,
    {
      id: 'sendingRegistrationEmail',
      header: 'E-mail de inscrição',
      mapper: ({ values }) => <EmailDate props={values} />,
    },
    {
      accessorKey: 'statusCompletingInterview',
      header: `${settingsTable.statusColumn}`,
      mapper: ({ values }) => <InterviewStatus props={values} />,
    },
    {
      accessorKey: 'statusInterview',
      header: `${settingsTable.resultColumn}`,
      mapper: ({ values }) => (
        <ItemResultEntrevista>
          <InterviewResult props={values} />
          <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae60}>
            {values.processingDate
              ? ` ${settingsTable.processingDateTitle}: ${formatDate(
                  new Date(values.processingDate),
                )}`
              : ''}
          </BaSeSmall1>
        </ItemResultEntrevista>
      ),
    },
    {
      header: 'Opções',
      mapper: ({ values, reloadData }) => (
        <ContentOptions>
          <BaSeActionItem
            position="top-right"
            minWidth="310px"
            closeOnAction={false}
            color={BaSeTheme.colors.institucionais.azulSebrae10}
            items={getMenuItems(values, reloadData, 1)}
          />
          {values.hasHistoric && (
            <BaSeShapeButton
              buttonType="button"
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
              nameIcon="file-search-alt"
              onClick={() => historico(values)}
              shape="square"
              size="medium"
              sizeIcon="medium"
              tooltip={{
                width: '150',
                direction: 'bottom',
                message: 'Visualizar histórico',
                color: `${BaSeTheme.colors.institucionais.cinzaSebrae60}`,
              }}
              type="tertiary"
            />
          )}
        </ContentOptions>
      ),
    },
  ];

  const columnRuralConfig = [
    {
      columnId: 'city.uf.initials',
      columnFilterIconProps: { shape: 'square' },
      renderColumnFilter: ({ setFilter, setTags, closeFilter }) => {
        return (
          <ColumnFilter
            setFilter={setFilter}
            setTags={setTags}
            closeFilter={closeFilter}
            columnId="ufs"
          />
        );
      },
    },
    {
      columnId: 'city.name',
      columnFilterIconProps: { shape: 'square' },
      renderColumnFilter: ({ setFilter, setTags, closeFilter }) => {
        return (
          <ColumnFilter
            setFilter={setFilter}
            setTags={setTags}
            closeFilter={closeFilter}
            columnId="cities"
          />
        );
      },
    },
    {
      columnId: 'situationInterview',
      columnFilterIconProps: { shape: 'square' },
      renderColumnFilter: ({ setFilter, setTags, closeFilter }) => {
        return (
          <ColumnRuralFilter
            setFilter={setFilter}
            setTags={setTags}
            closeFilter={closeFilter}
            columnId="situationInterview"
          />
        );
      },
    },
  ];

  const columnCommonConfig = [
    {
      columnId: 'city.uf.initials',
      columnFilterIconProps: { shape: 'square' },
      renderColumnFilter: ({ setFilter, setTags, closeFilter }) => {
        return (
          <ColumnFilter
            setFilter={setFilter}
            setTags={setTags}
            closeFilter={closeFilter}
            columnId="ufs"
          />
        );
      },
    },
    {
      columnId: 'city.name',
      columnFilterIconProps: { shape: 'square' },
      renderColumnFilter: ({ setFilter, setTags, closeFilter }) => {
        return (
          <ColumnFilter
            setFilter={setFilter}
            setTags={setTags}
            closeFilter={closeFilter}
            columnId="cities"
          />
        );
      },
    },
    {
      columnId: 'sendingRegistrationEmail',
      columnFilterIconProps: { shape: 'square' },
      renderColumnFilter: ({ setFilter, setTags, closeFilter }) => {
        return (
          <ColumnFilter
            setFilter={setFilter}
            setTags={setTags}
            closeFilter={closeFilter}
            columnId="emails"
          />
        );
      },
    },
    {
      columnId: 'statusCompletingInterview',
      columnFilterIconProps: { shape: 'square' },
      renderColumnFilter: ({ setFilter, setTags, closeFilter }) => {
        return (
          <ColumnFilter
            setFilter={setFilter}
            setTags={setTags}
            closeFilter={closeFilter}
            columnId="statusCompletingInterviews"
          />
        );
      },
    },
    {
      columnId: 'statusInterview',
      columnFilterIconProps: { shape: 'square' },
      renderColumnFilter: ({ setFilter, setTags, closeFilter }) => {
        return (
          <ColumnFilter
            setFilter={setFilter}
            setTags={setTags}
            closeFilter={closeFilter}
            columnId="statusInterviews"
          />
        );
      },
    },
  ];

  const columnConfig =
    moduleSelected?.id === 4 ? columnRuralConfig : columnCommonConfig;

  const getSelectionIconActions = React.useCallback(
    (isAllSelected, selectedItems) =>
      !isAllSelected && selectedItems.length === 0
        ? [
            {
              nameIcon: 'envelope',
              isDisabled: true,
              onClick: () => {},
            },
            {
              nameIcon: 'file-export',
              isDisabled: true,
              onClick: () => {},
            },
            {
              nameIcon: 'newspaper',
              isDisabled: true,
              onClick: () => {},
            },
            {
              nameIcon: 'newspaper',
              isDisabled: true,
              onClick: () => {},
            },
            {
              nameIcon: 'print',
              isDisabled: true,
              onClick: () => {},
            },
          ]
        : [],
    [],
  );

  const exportClassReport = React.useCallback(
    (interviews) => {
      if (
        interviews.filter((interview) => interview.statusInterview !== 'APTO')
          .length
      ) {
        handleAttention(
          'Relatório permitido somente para candidatos com o status da entrevista "Finalizada" ou "Certificada" e resultado "Apto".',
        );
        return;
      }

      if (interviews.length > 40) {
        handleAttention('Limite máximo de 40 candidatos por relatório.');
        return;
      }

      getClassReport(interviews.map((s) => s.id)).then((pdf) => {
        const nameReport = `Relatório da Turma-${format(
          new Date(),
          'dd-MM-yyyy',
        )}.pdf`;
        pdf && downloadPdf(pdf, nameReport);
      });
    },
    [downloadPdf, getClassReport, handleAttention],
  );

  const sendMultipleCertificate = React.useCallback(
    (isAllSelected, interviews, reloadData) => {
      const hasNotCertificate = interviews.filter(
        (interview) => interview.statusCompletingInterview !== 'CERTIFICADA',
      );
      if (hasNotCertificate.length > 0) {
        handleAttention(
          'O envio do certificado digital é permitido somente para os candidatos com status da entrevista "Certificada".',
        );
        return;
      }

      const totalEntrevistas = interviews.length;
      if (isAllSelected || totalEntrevistas > 100) {
        handleError(
          'Somente é permitido selecionar um máximo de 100 candidatos para o envio do certificado em lote.',
        );
        return;
      }

      openDialogSendMultipleCertificate(interviews, reloadData);
    },
    [handleAttention, handleError, openDialogSendMultipleCertificate],
  );

  const printMultipleCertificate = React.useCallback(
    (isAllSelected, interviews, reloadData) => {
      const totalEntrevistas = interviews.length;
      const hasNotCertificate = interviews.filter(
        (interview) => interview.statusCompletingInterview !== 'CERTIFICADA',
      );

      const idList = interviews.map((interview) => interview.id);

      if (hasNotCertificate.length > 0) {
        handleError(
          'A impressão dos certificados é permitida somente para os candidatos com status "Certificada".',
        );
        return;
      }

      if (isAllSelected || totalEntrevistas > 40) {
        handleAttention(
          'Somente é permitido selecionar um máximo de 40 candidatos para impressão dos certificados em lote.',
        );
        return;
      }

      getDownloadCertificate(idList).then((response) => {
        response && downloadPdf(response, 'certificado.pdf');
      });
    },
    [downloadPdf, getDownloadCertificate, handleAttention, handleError],
  );

  const sendInterviewReprocess = React.useCallback(
    (idsList) => {
      resendAnswerInterviewmutiple(idsList)
        .then(() =>
          handleSuccess(
            'Solicitação de reprocessamento da(s) entrevista(s) enviada com sucesso.',
          ),
        )
        .catch((error) => handleError(error));
    },
    [resendAnswerInterviewmutiple, handleError, handleSuccess],
  );

  const checkInterviewsForNonErrorResult = React.useCallback(
    (data) => {
      const nonErrorResult = data.filter(
        (it) => it.statusInterview !== 'ERRO_DE_PROCESSAMENTO',
      );

      if (nonErrorResult.length > 0) {
        handleAttention(
          'Reprocessamento permitido somente para as entrevistas com resultado "Erro de Processamento".',
        );
        return;
      }
      const idsList = data.map((it) => it.id);
      sendInterviewReprocess(idsList);
    },
    [handleAttention, sendInterviewReprocess],
  );

  const generateMultipleCertificate = React.useCallback(
    (isAllSelected, interviews, reloadData) => {
      const totalEntrevistas = interviews.length;

      if (isAllSelected || totalEntrevistas > 40) {
        handleError(
          'Somente é permitido selecionar um máximo de 40 candidatos para geração do certificado em lote.',
        );
        return;
      }

      const listaNaoAptos = interviews.filter(
        (interview) =>
          interview.statusInterview !== 'APTO' ||
          (interview.statusCompletingInterview !== 'FINALIZADA' &&
            interview.statusCompletingInterview !== 'EXPIRADA'),
      ).length;
      if (listaNaoAptos > 0) {
        handleError(
          'Geração dos certificados permitida somente para os candidatos com status "Finalizada" ou "Expirada" e resultado "Apto".',
        );
        return;
      }

      openDialogGenerateCertificate(interviews, reloadData);
    },
    [handleError, openDialogGenerateCertificate],
  );

  const getSelectionButtonActions = React.useCallback(
    (isAllSelected, selectedItems, reloadData) =>
      isAllSelected || selectedItems.length > 0
        ? [
            {
              leftIcon: 'envelope',
              value: 'Enviar e-mail de inscrição',
              type: 'tertiary',
              onClick: () => {
                sendEmailSubscription({
                  sendAll: isAllSelected,
                  idsInterviews: selectedItems.map((s) => s.id),
                }).then(() => reloadData());
              },
            },
            {
              leftIcon: 'file-export',
              value: 'Exportar lista',
              type: 'tertiary',
              onClick: () => {
                exportClassReport(selectedItems);
              },
            },
            {
              leftIcon: 'newspaper',
              value: 'Gerar certificado',
              type: 'tertiary',
              onClick: () => {
                generateMultipleCertificate(
                  isAllSelected,
                  selectedItems,
                  reloadData,
                );
              },
            },
            {
              leftIcon: 'newspaper',
              value: 'Enviar certificado',
              type: 'tertiary',
              onClick: () => {
                sendMultipleCertificate(
                  isAllSelected,
                  selectedItems,
                  reloadData,
                );
              },
            },
            {
              leftIcon: 'print',
              value: 'Imprimir certificado',
              type: 'tertiary',
              onClick: () => {
                printMultipleCertificate(
                  isAllSelected,
                  selectedItems,
                  reloadData,
                );
              },
            },
            hasRole('ADMINISTRADOR')
              ? {
                  leftIcon: 'system/arrow-go-back-line',
                  value: 'Reprocessar',
                  type: 'tertiary',
                  onClick: () => {
                    checkInterviewsForNonErrorResult(selectedItems);
                  },
                }
              : {},
          ]
        : [],
    [
      sendEmailSubscription,
      hasRole,
      checkInterviewsForNonErrorResult,
      exportClassReport,
      generateMultipleCertificate,
      sendMultipleCertificate,
      printMultipleCertificate,
    ],
  );

  const setDateFilter = React.useCallback((field, setFilter, period) => {
    if (!field) return;

    field && field.replace(/\D/g, '').length === 0
      ? setFilter((actualFilter) => {
          delete actualFilter[period];
          return { ...actualFilter };
        })
      : field.replace(/\D/g, '').length === 8 &&
        DATE_REGEX.test(field) &&
        setFilter((actualFilter) => ({
          ...actualFilter,
          [period]: field.split('/').reverse().join('-'),
        }));
  }, []);

  const buildCustomFilter = React.useCallback(
    (setFilter) => {
      return (
        <CustomFilterWrapper>
          <CustomFilterWrapperAlign>
            <BaSeSmall1 isBold>
              {settingsTable.custonFilterInscriptionDate}
            </BaSeSmall1>

            <AlignFilds>
              <BaSeDatePicker
                onBlur={(e) => {
                  if (initialDate === undefined) return;
                  if (e.target.value === '') return;
                  const dateFormated = formatDate(initialDate).toString();
                  setInitialDate((date) => date);
                  setDateFilter(dateFormated, setFilter, 'periodStart');
                }}
                size="small"
                onStartDateChange={setInitialDate}
                startDate={initialDate}
                onSelect={(date) => {
                  const dateFormated = formatDate(date).toString();
                  setInitialDate(date);
                  setDateFilter(dateFormated, setFilter, 'periodStart');
                }}
                placeholder="Data de início"
              />
              <BaSeDatePicker
                size="small"
                onBlur={(e) => {
                  if (finalDate === undefined) return;
                  if (e.target.value === '') return;
                  const dateFormated = formatDate(finalDate).toString();
                  setInitialDate((date) => date);
                  setDateFilter(dateFormated, setFilter, 'periodEnd');
                }}
                onStartDateChange={setFinalDate}
                startDate={finalDate}
                placeholder="Data de término"
                onSelect={(date) => {
                  const dateFormated = formatDate(date).toString();

                  setFinalDate(date);
                  setDateFilter(dateFormated, setFilter, 'periodEnd');
                }}
              />
            </AlignFilds>
          </CustomFilterWrapperAlign>
          <CustomFilterWrapperAlign>
            <BaSeSmall1 isBold>{settingsTable.custonFilterDate}</BaSeSmall1>
            <AlignFilds>
              <BaSeDatePicker
                size="small"
                startDate={initialProcessingDate}
                onStartDateChange={setInitialProcessingDate}
                onBlur={(e) => {
                  if (initialProcessingDate === undefined) return;
                  if (e.target.value === '') return;
                  const dateFormated = formatDate(
                    initialProcessingDate,
                  ).toString();
                  setInitialProcessingDate((date) => date);
                  setDateFilter(
                    dateFormated,
                    setFilter,
                    'initialProcessingDate',
                  );
                }}
                onSelect={(date) => {
                  const dateFormated = formatDate(date).toString();
                  setInitialProcessingDate(date);
                  setDateFilter(
                    dateFormated,
                    setFilter,
                    'initialProcessingDate',
                  );
                }}
                placeholder="Data de início"
              />
              <BaSeDatePicker
                size="small"
                startDate={finalProcessingDate}
                placeholder="Data de término"
                onStartDateChange={setFinalProcessingDate}
                onBlur={(e) => {
                  if (finalProcessingDate === undefined) return;
                  if (e.target.value === '') return;
                  const dateFormated =
                    formatDate(finalProcessingDate).toString();
                  setFinalProcessingDate((date) => date);
                  setDateFilter(dateFormated, setFilter, 'finalProcessingDate');
                }}
                onSelect={(date) => {
                  const dateFormated = formatDate(date).toString();

                  setFinalProcessingDate(date);
                  setDateFilter(dateFormated, setFilter, 'finalProcessingDate');
                }}
              />
            </AlignFilds>
          </CustomFilterWrapperAlign>
          <CustomFilterWrapperAlign>
            <BaSeSmall1 isBold>Meus cadastros</BaSeSmall1>
            <AlignFilds>
              <BaSeToggler
                value={myRecords}
                onChange={() => {
                  setMyRecords((prev) => {
                    setFilter((currentFilter) => ({
                      ...currentFilter,
                      myRecords: !prev,
                    }));

                    return !prev;
                  });
                }}
              />
            </AlignFilds>
          </CustomFilterWrapperAlign>
          <ContentActions>
            <SelectionActionsButtons
              isAllSelected={isAllSelect}
              itemsSelectTable={itemsSelectTable}
              moduleSelected={moduleSelected}
            />
          </ContentActions>
        </CustomFilterWrapper>
      );
    },
    [
      finalDate,
      finalProcessingDate,
      formatDate,
      initialDate,
      initialProcessingDate,
      isAllSelect,
      itemsSelectTable,
      moduleSelected,
      myRecords,
      setDateFilter,
      settingsTable.custonFilterDate,
      settingsTable.custonFilterInscriptionDate,
    ],
  );

  const clearAll = React.useCallback(() => {
    setInitialDate();
    setFinalDate();
    setInitialProcessingDate();
    setFinalProcessingDate();
    fetchData({
      filter: {
        fieldOfResearch: '',
        sortField: 'interviewDate',
        ufs:
          cache.getItem(cacheKeySebrae) === 'NA'
            ? ''
            : cache.getItem(cacheKeySebrae),
        cities: '',
        emails: '',
        statusInterviews: '',
        statusCompletingInterviews: '',
        filterType: '',
        filterCityName: '',
        initialProcessingDate: '',
        finalProcessingDate: '',
        periodStart: '',
        periodEnd: '',
      },
      page: 0,
      sort: { type: 'DESC' },
    });
  }, [fetchData]);

  const handleUpdateColumns = React.useCallback(() => {
    handleColumns(filters);
  }, [filters, handleColumns]);

  const returnDescription = React.useCallback(() => {
    if (showContentManageClass) {
      return 'Esse é seu espaço para criar turmas e fazer a gestão dos participantes inscritos para o Seminário.';
    } else if (showManagerRegional) {
      return 'Este é seu espaço para criar novas regionais e fazer a gestão das cidades e gestores vinculados.';
    } else {
      return 'Esse é seu espaço para inscrever e fazer a gestão das entrevistas dos candidatos ao Empretec.';
    }
  }, [showContentManageClass, showManagerRegional]);

  return (
    <ListContainer>
      <Content gradientColor={moduleSelected?.settingsMap?.primaryColor}>
        <BaSeContainer delimitedOnBreakpoint="desktop">
          <Banner
            imageBannerManager={
              moduleSelected?.settingsMap?.empretecManagerActorSmall
            }
          />
          <DataTableWrapper>
            <BoxHeader>
              <BoxUserName>
                <BaSeHeading4
                  color={BaSeTheme.colors.institucionais.cinzaSebrae75}
                  isBold={true}
                >
                  {isAuthenticated && `Olá, ${tokenInfo?.name}!`}
                </BaSeHeading4>
                <BaSeParagraph
                  color={BaSeTheme.colors.institucionais.cinzaSebrae75}
                >
                  {returnDescription()}
                </BaSeParagraph>
              </BoxUserName>

              <>
                {showContentManageClass ? (
                  <BaSeButton
                    buttonType="button"
                    color={BaSeTheme.colors.institucionais.cinzaSebrae10}
                    leftIcon="plus"
                    loadingText="Carregando..."
                    rightIcon=""
                    size="medium"
                    type="secondary"
                    value="Nova Turma"
                    width=""
                    onClick={() => {
                      openDialogNewClassRoom(handleUpdateColumns);
                    }}
                  />
                ) : showManagerRegional ? (
                  <BaSeButton
                    buttonType="button"
                    color={BaSeTheme.colors.institucionais.cinzaSebrae10}
                    leftIcon="plus"
                    loadingText="Carregando..."
                    rightIcon=""
                    size="medium"
                    type="secondary"
                    value="Nova Regional"
                    width=""
                    onClick={() => openDialogNewRegional(fetchRegional)}
                  />
                ) : (
                  <BaSeButton
                    buttonType="button"
                    color={BaSeTheme.colors.institucionais.cinzaSebrae10}
                    leftIcon="plus"
                    loadingText="Carregando..."
                    rightIcon=""
                    size="medium"
                    type="secondary"
                    value="Novo Candidato"
                    width=""
                    onClick={() =>
                      openDialogCpf(
                        openDialogActiveInterview,
                        openDialogNewCandidate,
                        fetchData,
                      )
                    }
                  />
                )}
              </>
            </BoxHeader>

            {showContentManageClass ? (
              <ManageClass />
            ) : showManagerRegional ? (
              <ManageRegional
                loading={loadingRegional}
                fetchRefional={fetchRegional}
                data={dataRegional}
              />
            ) : (
              <MainContent
                setShowAvaliableRuralCandidate={setShowAvaliableRuralCandidate}
                dataToAvaliationRural={dataToAvaliationRural}
                showNotas={showNotas}
                setShowNotas={setShowNotas}
                showAvaliableCandidate={showAvaliableCandidate}
                cpfSearched={cpfSearched}
                notasRespostas={notasRespostas}
                respostas={respostas}
                fetchData={fetchData}
                setShowAvaliableCandidate={setShowAvaliableCandidate}
                respostasQuestionarioStartup={respostasQuestionarioStartup}
                showAvaliableRuralCandidate={showAvaliableRuralCandidate}
                configTable={
                  moduleSelected?.id === 4 ? configRuralTable : configTable
                }
                columnConfig={columnConfig}
                cache={cache}
                data={data}
                loading={loading}
                hasCustomFilter={hasCustomFilter}
                cacheKeySebrae={cacheKeySebrae}
                cacheKey={cacheKey}
                clear={clear}
                clearAll={clearAll}
                getSelectionIconActions={getSelectionIconActions}
                buildCustomFilter={buildCustomFilter}
                getSelectionButtonActions={getSelectionButtonActions}
                hasApprove={hasApprove}
                setHasApprove={setHasApprove}
                setItemsSelectTable={setItemsSelectTable}
                setIsAllSelect={setIsAllSelect}
                textFilter={textFilter}
                moduleSelected={moduleSelected}
                settingsMap={moduleSelected?.settingsMap}
              />
            )}
          </DataTableWrapper>
        </BaSeContainer>
      </Content>
    </ListContainer>
  );
};
